import React, { createContext, useContext, useReducer } from 'react'
import PropTypes from 'prop-types'

const SearchContext = createContext(null)

const initialState = {
  summonerName: '',
  region: 'EUNE',
  isLoading: false,
  message: 'Please enter a summoner name and select a region.',
  searchHistory: [],
  value: 0,
  update: false,
  data: {},
  userData: {},
  tftQueue: 'ranked',
  tftCount: 10,
  tabCache: {}
}

const actionTypes = {
  SET_SUMMONER: 'SET_SUMMONER',
  SET_REGION: 'SET_REGION',
  SET_LOADING: 'SET_LOADING',
  SET_MESSAGE: 'SET_MESSAGE',
  SET_SEARCH_HISTORY: 'SET_SEARCH_HISTORY',
  SET_TAB: 'SET_TAB',
  SET_UPDATE: 'SET_UPDATE',
  SET_DATA: 'SET_DATA',
  SET_USER_DATA: 'SET_USER_DATA',
  SET_TFT_QUEUE: 'SET_TFT_QUEUE',
  SET_TFT_COUNT: 'SET_TFT_COUNT',
  SET_TAB_CACHE: 'SET_TAB_CACHE'
}

function searchReducer (state, action) {
  switch (action.type) {
    case actionTypes.SET_SUMMONER:
      return { ...state, summonerName: action.payload }
    case actionTypes.SET_REGION:
      return { ...state, region: action.payload }
    case actionTypes.SET_LOADING:
      return { ...state, isLoading: action.payload }
    case actionTypes.SET_MESSAGE:
      return { ...state, message: action.payload }
    case actionTypes.SET_SEARCH_HISTORY:
      return { ...state, searchHistory: action.payload }
    case actionTypes.SET_TAB:
      return { ...state, value: action.payload }
    case actionTypes.SET_UPDATE:
      return { ...state, update: action.payload }
    case actionTypes.SET_DATA:
      return { ...state, data: action.payload }
    case actionTypes.SET_USER_DATA:
      return { ...state, userData: action.payload }
    case actionTypes.SET_TFT_QUEUE:
      return { ...state, tftQueue: action.payload }
    case actionTypes.SET_TFT_COUNT:
      return { ...state, tftCount: action.payload }
    case actionTypes.SET_TAB_CACHE:
      return { ...state, tabCache: { ...state.tabCache, [action.payload.tab]: action.payload.data } }
    default:
      return state
  }
}

export function SearchProvider ({ children }) {
  const [state, dispatch] = useReducer(searchReducer, initialState)

  return (
    <SearchContext.Provider value={{ state, dispatch, actionTypes }}>
      {children}
    </SearchContext.Provider>
  )
}

SearchProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export function useSearchContext () {
  const context = useContext(SearchContext)
  if (!context) {
    throw new Error('useSearchContext must be used within a SearchProvider')
  }
  return context
}
